module.exports = __webpack_public_path__ + "img/edit.00024569.png";